import {Translatable} from 'common/i18n';

// NOTE: While we use the term digests internally everything external should
// stick to the new "Subscription"/"subscribe" terminology.
// https://mixpanel.slack.com/archives/C06AE1PB2JF/p1708532996312809?thread_ts=1708531523.786939&cid=C06AE1PB2JF
export const DIGEST_COPY: {[key in string]: Translatable} = {
  createDigestSuccess: ({t}) => t(`subscriptions.notice.create-success`),
  createDigestError: ({t}) => t(`subscriptions.notice.create-error`),
  deleteDigestError: ({t}) => t(`subscriptions.notice.delete-error`),
  deleteDigestSuccess: ({t}) => t(`subscriptions.notice.delete-success`),
  deleteDigestTitle: ({t}) => t(`subscriptions.notice.delete-title`),
  emailNoResults: ({t}) => t(`subscriptions.notice.email-no-results`),
  missingPermissions: ({t}) => t(`subscriptions.notice.missing-permissions`),
  sendTestDigestEmailSuccess: ({t}) => t(`subscriptions.notice.send-test-email-success`),
  sendTestDigestSlackSuccess: ({t}) => t(`subscriptions.notice.send-test-slack-success`),
  sendTestDigestEmailConfirmation: ({t}) => t(`subscriptions.notice.send-test-email-confirmation`),
  sendTestDigestSlackConfirmation: ({t}) => t(`subscriptions.notice.send-test-slack-confirmation`),
  removingFinalSubscriberWillDeleteDigestPrompt: ({t}) => t(`subscriptions.notice.last-subscriber-prompt`),
  updateDigestError: ({t}) => t(`subscriptions.notice.update-error`),
  updateDigestSuccess: ({t}) => t(`subscriptions.notice.update-success`),
};
